import "./styles.css";
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../../utils/motion';

function OrderItems({products,order}) {



    return (
        <motion.div 
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
        className='section-card flex1'>
            <div className="title">تفاصيل الطلب</div>
            <div className="df-c !gap-3" >
            {products.map((item, index) => (
                    <motion.div 
                    variants = {fadeIn("right", "tween", (index+1)*0.2, 1)}
                    className='df item ai-stretch itd' key={item._id}>
                        <img className="w-20 aspect-square rounded-xl" src={item?.image?.[0]?.url} alt={item.name} />
                        <div className="df-c jc-sb text flex1">
                            <div className="name">{item.name}</div>
                            <div className="sku">رمز المنتج: <span className='sku-color'>{item.sku}</span></div>
                            <div className="qte ">الكمية: <span className='font-bold'>{item.qteToBuy}</span></div>
                        </div>
                        <div>
                        <span className='font-bold'>${item.discount}</span>
                        </div>
                </motion.div>
            ))}
            </div>
            <hr />
            <div className="bill w-1/2 mr-auto">
                <div className="df-c !gap-3">
                    <div className="df w-full jc-sb">
                        <span className='w-26 text-center'>المجموع الفرعي</span>
                        <span className='font-bold'>{(order.payAmount - (order.deliveryInfo.cost? order.deliveryInfo.cost : 0)).toFixed(2)}$</span>
                    </div>
                    <div className="df w-full jc-sb">
                        <span className='w-24 text-center'>الشحن</span>
                        <span className='font-bold'>{order.deliveryInfo.cost}$</span>
                    </div>
                    <div className="df w-full jc-sb">
                        <span className='font-bold w-24 text-center'>المجموع الكلي</span>
                        <span className='font-bold'>{order.payAmount}$</span>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default OrderItems;
